// 供应链主数据API
export default {
  // 附件上传
  OSS_UPLOAD_API: '/maindata/dict/ossUpload',
  // 字典表查询
  DICT_LIST: '/maindata/dictData/listDataDictByDataType',
  // 获取人员信息
  GET_LIST_PERSON: '/maindata/person/listPerson',
  // 合作伙伴列表
  LIST_PARTNER: '/maindata/partners/listPartner',
  // 合作伙伴扩展列表
  LIST_PARTNEREXTEND: '/maindata/partners/getPartnerExtendByPage',
  // 合作伙伴扩展列表--不过滤重复的
  LIST_PARTNEREXTEND_NO_FILTER: '/maindata/partners/getSupplyPartnerExtendByPage',
  // 合作伙伴详情
  GET_PARTNER: '/maindata/partners/getPartner',
  // 列表
  LIST_SUPPLIERS: '/maindata/supplier/listSuppliers',
  // 新增
  ADD_SUPPLIER: '/maindata/supplier/addSupplier',
  // 详情
  GET_SUPPLIER_DETAIL: '/maindata/supplier/getSupplierDetail',
  // 导出
  EXPORT_SUPPLIERS: '/maindata/supplier/exportSuppliers',
  // 导出详情
  EXPORT_SUPPLIERS_DETAIL: '/maindata/supplier/exportSupplierDetail',
  // 禁用启用
  ENABLE_SUPPLIER: '/maindata/supplier/enableSupplier',
  // 驳回、审批
  UPDATE_IS_REJECT: '/maindata/supplier/batchAudit',
  // 查重
  DUPLICATE_CHECK: '/maindata/supplier/duplicateCheck',
  // 合并
  MERGE_SUPPLIER: '/maindata/supplier/mergeSupplier',
  // 供应链主体导入
  IMPORT_SUPPLIER: '/maindata/supplier/importSupplier',
  // 扩展
  EXTEND_SUPPLIER: '/maindata/supplier/extendSupplier',
  // 供应链主体名称列表查询
  LIST_SUPPLIER_NAMES: '/maindata/supplier/listSupplierNames',
  // 获取供应商列表 | 客户列表
  LIST_SUPPLIER_PARTNERS: '/maindata/supplier/listSupplierPartners',
  // 币种数据(币种管理)
  LIST_CURRENCY: '/maindata/currency/listCurrency',
  //保存银行数据、联系人数据、附件数据
  B_P_SAVE: '/maindata/supplier/batchSavePartnerBankAndPerson',
  // 批量扩展
  SAVE_SUPPLY_EXTEND: '/maindata/supplier/saveSupplierExtend',
  // 合作伙伴根据编码查询
  LIST_GETPARTNERADDRESSINFO: '/maindata/partners/getPartnerAddressInfo',
};
